import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { httpOptions } from '../../configurations/configuration';

// One service for every entity that supports the "Set Display Order" popup
// (menu category, page category, carousel). Each exposes the same two admin
// endpoints under its own base path, so the caller passes the base URL from
// environment (e.g. environment.getMenuCategoryUrl) instead of us duplicating
// this service three times.
@Injectable({
  providedIn: 'root'
})
export class DisplayOrderService {

    constructor(private http: HttpClient) { }

    private endpoint(baseUrl: string): string {
        return environment.apiURL + environment.adminApiUrl + baseUrl + '/displayindex';
    }

    // Published rows only, already sorted by their current display index.
    getDisplayOrder(baseUrl: string): Observable<any> {
        return this.http.get<any>(this.endpoint(baseUrl));
    }

    // `ids` is the ordered list — position in the array becomes the display index.
    saveDisplayOrder(baseUrl: string, ids: any[]): Observable<any> {
        return this.http.post(this.endpoint(baseUrl), { ids: ids }, httpOptions);
    }
}
